// extracted by mini-css-extract-plugin
export default {"container":"_4WYOr9ffL3mr7BIiGVIiV6","firstItem":"_12KZcY8uknelKQMEj69TY5","secondItem":"_2DzpWDqiSgm1tx3YQJqr1j","toggleLink":"_2JsUFDEHrGFloWEIhU9p9B"};